import { useContext, useEffect } from "react";
import MobileHeader from "routes/mobile/home/layout/MobileHeader";
import DesktopHeader from "routes/front/header/DesktopHeader";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import TabletHeader from "./TabletHeader";

function Header() {
    const { isMobile, deviceType } = useContext(BrowserDetectContext);
    return (
        <>
            {
                isMobile ?
                    <MobileHeader />
                    :
                    <DesktopHeader />
            }
        </>
    );
}

export default Header;